import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';

// libraries
import { Button, Container, Card, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import moment from 'moment';

// api
import { uploadBannerImage, createBanner } from 'apis/admin/pageApi';

// components
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ReactDatePicker from 'components/DatePicker/ReactDatePicker';
import PreviewBanner from 'components/Banner/PreviewBanner';

function CreateBanner(props) {
  const user = useSelector(state => state.user);

  const [groups, setGroups] = useState([]);
  const [startDateState, setStartDateState] = useState();   // 배너 시작 일시
  const [endDateState, setEndDateState] = useState();       // 배너 종료 일시
  const [imageData, setImageData] = useState();             // 이미지 데이터를 담는 state
  const [showPreview, setShowPreview] = useState(false);    // 미리 보기 모달창 활성화 여부 state

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  });

  // 기본값 세팅(default value)
  useEffect(() => {
    if (groups.length > 0) {
      setValue('activated', 1);
    }
  }, [groups]);

  // 선택한 이미지를 state에 저장
  const storeImage = (event) => {
    setImageData(event.target.files[0]);
  };

  // 사용자가 업로드한 이미지 삭제
  const deleteUploaded = () => {
    let fileElement = document.querySelector('input[type="file"].form-control-file');
    fileElement.value = '';
    setImageData();
  };

  // 저장 전 이미지 업로드
  const imageUpload = async () => {
    const formData = new FormData();
    formData.append('image', imageData);

    let result;
    await uploadBannerImage(formData)
      .then(response => {
        if (response.data.success) {
          result = response.data.result.replace(/\\/g, '/');
        }
      })
      .catch(error => {
        console.error('error occured in Page/Banner/CreateBanner.js - imageUpload() ', error);

        Swal.fire({
          icon: 'error',
          title: '배너 이미지를 저장할 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });

    return result;
  };

  // 배너 추가
  const onSubmit = async (data) => {
    let dataToSubmit = {};
    for (const key in data) {
      if (Number.isNaN(data[key])) {
        continue;
      }
      if (key === 'width' || key === 'height' || key === 'order') {
        if (data[key] === '') {
          dataToSubmit[key] = null;
          continue;
        }
      }
      dataToSubmit[key] = data[key];
    }
    if (startDateState) {
      dataToSubmit.start_date = String(moment(startDateState).format('YYYY-MM-DD'));
    }
    if (endDateState) {
      dataToSubmit.end_date = String(moment(endDateState).format('YYYY-MM-DD'));
    }
    dataToSubmit.image = '';
    dataToSubmit.mem_id = user.userData.id;

    const uploadResult = await imageUpload();
    dataToSubmit.image = uploadResult;

    if (dataToSubmit.image !== '') {
      await createBanner(dataToSubmit)
        .then(response => {
          if (response.data.success) {
            Swal.fire({
              icon: 'success',
              title: '배너 추가를 완료했습니다.',
            }).then(() => {
              props.history.push('/admin/pages/banner/list');
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              title: '배너를 추가할 수 없습니다.',
              text: '잠시 후 다시 시도해주세요.',
            }).then(() => {
              return;
            });
          }
        })
        .catch(error => {
          console.error('error occured in Page/Banner/CreateBanner.js - onSubmit() ', error);
  
          Swal.fire({
            icon: 'error',
            title: '배너를 저장할 수 없습니다.',
            text: '잠시 후 다시 시도해주세요.',
          }).then(() => {
            return;
          });
        });
    }
  };

  return (
    <div>
      <SimpleHeader parentName="페이지 설정" name="배너 관리 - 추가" />
      <Container className="mt--6" fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <div className="pl-lg-4 pr-lg-4 pt-4">
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        배너 이미지 업로드
                      </Form.Label>
                      <Col sm={4}>
                        <Form.File
                          className="text-sm"
                          onChange={storeImage}
                          isInvalid={errors.image}
                        />
                        <Form.Text muted>
                          gif, jpg, png 형식의 이미지를 업로드를 할 수 있습니다.<br />
                          사이즈는 가로 576px, 세로 720px으로 업로드 해주세요.
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                          {errors.image && '이미지를 업로드해주세요.'}
                        </Form.Control.Feedback>
                        {imageData && (
                          <Form.Text className="mt-2">
                            <span
                              className="text-danger mr-2"
                              style={{ cursor: 'pointer' }}
                              onClick={deleteUploaded}
                            >
                              삭제
                            </span>
                          </Form.Text>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        배너 이미지 설명
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control type="text" {...register('title')} />
                      </Col>
                    </Form.Group>
                    {/* <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        시작일
                      </Form.Label>
                      <Col sm={4}>
                        <ReactDatePicker myDate={startDateState} setMyDate={setStartDateState} minDate={new Date(moment())} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        종료일
                      </Form.Label>
                      <Col sm={4}>
                        <ReactDatePicker myDate={endDateState} setMyDate={setEndDateState} />
                      </Col>
                    </Form.Group> */}
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        배너 URL
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control type="text" {...register('url')} />
                      </Col>
                    </Form.Group>
                    {/* <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        배너 크기
                      </Form.Label>
                      <Col sm={2}>
                        <InputGroup className="mb-2">
                          <InputGroup.Prepend>
                            <InputGroup.Text className="border-0 pl-0 text-sm text-default">
                              가로
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control type="number" {...register('width')} />
                          <InputGroup.Append>
                            <InputGroup.Text className="border-0 pr-0 text-sm text-default">
                              px
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                      <Col sm={2}>
                        <InputGroup className="mb-2">
                          <InputGroup.Prepend>
                            <InputGroup.Text className="border-0 pl-0 text-sm text-default">
                              세로
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control type="number" {...register('height')} />
                          <InputGroup.Append>
                            <InputGroup.Text className="border-0 pr-0 text-sm text-default">
                              px
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                      <Form.Text muted>
                        입력하지 않으면 업로드한 원본 크기대로 출력됩니다.
                      </Form.Text>
                    </Form.Group> */}
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        배너 링크 새 창 여부
                      </Form.Label>
                      <Col sm={2}>
                        <Form.Control
                          as="select"
                          custom
                          {...register('target')}
                        >
                          <option
                            value="_self"
                            onChange={() => setValue('target', '_self')}
                          >
                            현재 창
                          </option>
                          <option
                            value="_blank"
                            onChange={() => setValue('target', '_blank')}
                          >
                            새 창
                          </option>
                        </Form.Control>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        배너 표시 기기
                      </Form.Label>
                      <Col sm={2}>
                        <Form.Control
                          as="select"
                          custom
                          {...register('device')}
                        >
                          <option
                            value="all"
                            onChange={() => setValue('device', 'all')}
                          >
                            모든 기기
                          </option>
                          <option
                            value="pc"
                            onChange={() => setValue('device', 'pc')}
                          >
                            PC
                          </option>
                          <option
                            value="mobile"
                            onChange={() => setValue('device', 'mobile')}
                          >
                            모바일
                          </option>
                        </Form.Control>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        정렬 순서
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="number"
                          defaultValue={0}
                          {...register('order')}
                        />
                        <Form.Text muted>
                          정렬 순서가 작은 값이 먼저 출력됩니다.
                        </Form.Text>
                      </Col>
                    </Form.Group>
                    <fieldset>
                      <Form.Group as={Row} className="align-items-center">
                        <Form.Label
                          as="legend"
                          column
                          sm={2}
                          className="text-sm"
                        >
                          활성화 여부
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Check
                            type="radio"
                            label="활성화"
                            className="text-sm activated-radio"
                            name="activated"
                            id="activated"
                            inline
                            defaultChecked
                            value={1}
                            onClick={() => setValue('activated', 1)}
                          />
                          <Form.Check
                            type="radio"
                            label="비활성화"
                            className="text-sm activated-radio"
                            name="activated"
                            id="inactivated"
                            inline
                            value={0}
                            onClick={() => setValue('activated', 0)}
                          />
                        </Col>
                      </Form.Group>
                    </fieldset>
                  </div>
                  <div className="text-center pt-5">
                    <Button
                      type="button"
                      variant="info"
                      disabled={!imageData}
                      onClick={() => setShowPreview(true)}
                    >
                      미리 보기
                    </Button>
                    <Button type="submit" variant="primary">
                      배너 추가
                    </Button>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => {
                        props.history.push('/admin/pages/banner/list');
                      }}
                    >
                      목록으로
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Form>
        <PreviewBanner
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          width={getValues('width')}
          height={getValues('height')}
          image={imageData}
          title={getValues('title')}
        />
      </Container>
    </div>
  );
}

export default withRouter(CreateBanner);
